<div class="qld-profile-completion">
    <div class="card mt-15 px-20">
        <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12 col-12">
                <h1 class="user-title fs-18">Queensland Department of Education <span
                        class="status_qld_verification {{qldData?.status}} ml-10"> {{qldData?.status == 'A' ? 'Account
                        activated' : qldData?.status == 'AH' ? 'Activation Hold' : qldData?.status == 'DP' ?
                        'Deactivated Profile' : 'Details not found' }} </span></h1>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12 col-12 justify-content-end d-flex">
                @if (this.from !== 'qld-modal') {
                <!-- <svg (click)="qldProfileCompletionmodel()" *ngIf="qldData?.status == 'A'" xmlns="http://www.w3.org/2000/svg"
                    width="16" height="21" fill="currentColor" class="bi bi-pencil-fill c-p" viewBox="0 0 16 22">
                    <path
                    d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                </svg> -->
                @if(schoolProps.properties.user_type == 'Teacher' && (qldData?.status == 'A' || qldData?.status ==
                'DP')){
                <!-- Edit -->
                <a (click)="qldProfileCompletionmodel()" class="c-p text-regular-bold clr-cc-vilot mt-3"
                    *ngIf="qldData?.status == 'A'">
                    <i class="bi bi-pencil me-1"></i>Edit
                </a>
                @if(qldData?.role_type != 'DRT' && qldData?.role_type != 'LRT'){
                <!-- Delete Account -->
                <!-- <a class="c-p text-regular-bold clr-cc-vilot ms-3" (click)="deleteQLDAccount()">
                            <i class="bi bi-trash me-1"></i>Delete account
                        </a> -->
                <!-- Deactivate Account -->

                @if(qldData?.status != 'DP'){
                <span [ngbTooltip]="!qldData?.can_reactivate ? 'Please try after 30 mins from reactivation' : null">
                    <a placement="top" class="c-p text-regular-bold clr-cc-vilot ms-3"
                        [class.input-cursor-na]="!qldData?.can_reactivate" (click)="openDeactivateConfirmModal()">
                        <i class="bi bi-person-dash me-1"></i>Deactivate account
                    </a>
                </span>
                }
                }
                }
                }
            </div>
            <!-- <div class="col-12 d-flex flex-column align-items-end mt-10">
                <a class="cc-blue c-p text-regular-medium fs-16 mb-2">delete account</a>
                <a class="cc-blue c-p text-regular-medium fs-16">delete account</a>
            </div> -->
            @if(qldData?.status != 'DP'){
            @if(qldData?.role_type == 'DRT' || qldData?.role_type == 'LRT'){
            <div class="role-info-box p-3 mt-12 ms-2 rounded">
                <p class="txt-regular mb-4">
                    Role type:
                    <span class="role_tag_qld {{qldData?.role_type}} user-title-m">
                        <!-- <svg
                            xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="currentColor"
                            class="bi bi-mortarboard" viewBox="0 0 16 18">
                            <path
                                d="M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.275a.5.5 0 0 0 .025-.917zM8 8.46 1.758 5.965 8 3.052l6.242 2.913z" />
                            <path
                                d="M4.176 9.032a.5.5 0 0 0-.656.327l-.5 1.7a.5.5 0 0 0 .294.605l4.5 1.8a.5.5 0 0 0 .372 0l4.5-1.8a.5.5 0 0 0 .294-.605l-.5-1.7a.5.5 0 0 0-.656-.327L8 10.466zm-.068 1.873.22-.748 3.496 1.311a.5.5 0 0 0 .352 0l3.496-1.311.22.748L8 12.46z" />
                        </svg>  -->
                        {{qldData?.role_type}}</span>
                </p>

                <p class="txt-regular mb-4">
                    Period - start date:<span class="text-regular-bold ms-2">{{qldData?.contract_start_date |
                        date:"dd/MM/yyyy"}}</span>
                </p>

                <p class="txt-regular mb-4">
                    Period - end date:<span class="text-regular-bold ms-2">{{qldData?.contract_end_date |
                        date:"dd/MM/yyyy"}}</span>
                </p>

                <p class="txt-regular mb-4">
                    Roster AM:<span class="text-regular-bold ms-2">{{qldData?.payweek_am}}</span>
                </p>

                <p class="txt-regular mb-4">
                    Roster PM:<span class="text-regular-bold ms-2">{{qldData?.payweek_pm}}</span>
                </p>

                @if(qldData?.is_off_pay_week){
                <p class="txt-regular mb-4">
                    Off payweek roster AM:<span class="text-regular-bold ms-2">{{qldData?.off_payweek_am}}</span>
                </p>

                <p class="txt-regular mb-4">
                    Off payweek roster PM:<span class="text-regular-bold ms-2">{{qldData?.off_payweek_pm}}</span>
                </p>
                }

                <p class="txt-regular mb-4">
                    Appointed base school:<span class="text-regular-bold ms-2">{{qldData?.base_school}}</span>
                </p>

                <p *ngIf="qldData?.role_type == 'DRT'" class="txt-regular mb-0">
                    Appointed cluster school(s):<span class="text-regular-bold ms-2">{{qldData?.school}}</span>
                </p>
            </div>
            }@else {
            <p class="text-regular grey-4 mt-10 mb-10 fs-14">Update your relief teacher profile to work at Queensland
                Department of Education schools.</p>
            }
            <div class="bce_question">
                <div class="bce_question">
                    <div class="bce_question">
                        <div class="accordion" id="QLDAccordion">
                            <!-- Mandatory questions -->
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="mandatoryHeading">
                                    <button class="accordion-button grey-2 text-regular-bold" type="button"
                                        data-bs-toggle="collapse" data-bs-target="#mandatoryCollapse"
                                        aria-expanded="true" aria-controls="mandatoryCollapse">
                                        Employee Details
                                        <span class="">
                                            <!-- Down arrow SVG -->
                                            <svg width="16" height="16" fill="currentColor"
                                                class="bi bi-caret-down-fill ms-2" viewBox="0 0 16 16">
                                                <path
                                                    d="M7.247 11.14l-4.796-5.481C1.825 5.21 2.16 4.5 2.813 4.5h10.374c.653 0 .988.71.362 1.159l-4.796 5.481a1 1 0 0 1-1.506 0z" />
                                            </svg>
                                        </span>
                                    </button>
                                </h2>
                                <div id="mandatoryCollapse" class="accordion-collapse collapse show"
                                    aria-labelledby="employeeDetails">
                                    <div class="accordion-body p-0">
                                        <!-- Mandatory questions content here -->
                                        <p class="txt-regular mt-8">
                                            Legal first name:<span
                                                class="text-regular-bold ms-2">{{qldData?.first_name}}</span>
                                        </p>
                                        <p class="txt-regular mt-8">
                                            Legal last name:<span
                                                class="text-regular-bold ms-2">{{qldData?.last_name}}</span>
                                        </p>
                                        <!-- <p class="txt-regular mt-8">
                                            SPID:<span class="text-regular-bold ms-2">{{qldData?.last_name}}</span>
                                        </p>                                         -->
                                        <p class="txt-regular mt-8"
                                            *ngIf="schoolProps.properties.user_type == 'Tracer'">
                                            IDM GUID: <span class="text-regular-bold ms-2">{{qldData?.eq_number}}</span>
                                        </p>
                                        <p class="txt-regular mt-8"
                                            *ngIf="schoolProps.properties.user_type == 'Tracer'">
                                            Classcover ID:<span class="text-regular-bold ms-2">{{qldData?.id}}</span>
                                        </p>
                                        <p class="txt-regular mt-8">
                                            Classcover status:<span
                                                class="text-regular-bold ms-2">{{qldData?.meta?.classCoverStatus == "A"
                                                ? 'Active' : 'Inactive'}}</span>
                                        </p>
                                        <p class="txt-regular mt-8" *ngIf="schoolProps.properties.role_code != 'AT'">
                                            Employee number:<span
                                                class="text-regular-bold ms-2">{{qldData?.employee_id}}</span>
                                        </p>
                                        <!-- <p class="txt-regular mt-8"
                                            *ngIf="schoolProps.properties.user_type != 'School'">
                                            Date of birth:<span class="text-regular-bold ms-2">{{qldData?.dob |
                                                date:"dd/MM/yyyy"}}</span>
                                        </p> -->
                                        <p class="txt-regular mt-8" *ngIf="schoolProps.properties.role_code != 'AT'">
                                            QCT number:
                                            <span class="text-regular-bold ms-2">{{qldData?.qct_number}}</span>
                                        </p>
                                        <p class="txt-regular mt-8"
                                            *ngIf="schoolProps.properties.user_type == 'Tracer' || schoolProps.properties.user_type == 'School'">
                                            QCT evidence:
                                            <span
                                                class="text-regular-bold ms-2">{{qldData?.meta?.qctRegistrationStatus}}</span>
                                        </p>
                                        @if(schoolProps.properties.user_type != 'Teacher'){
                                        <ng-container *ngFor="let training of qldData?.meta?.training; let i = index">
                                            <p class="txt-regular mt-8">
                                                {{ trainingMap[training.course] || training.course }}
                                                <span [ngClass]="{
                                                        'qld-training-completed': training.result === 'Green',
                                                        'qld-training-pending': training.result === 'Amber',
                                                        'qld-training-not-completed': training.result === 'Red'
                                                        }">
                                                    ✔
                                                    <!-- <i class="bi bi-check-circle-fill"></i> -->
                                                </span>
                                            </p>
                                        </ng-container>
                                        }
                                        <p class="txt-regular mt-8" *ngIf="qldData?.meta?.reliefRole">
                                            Relief role:<span class="text-regular-bold ms-2">
                                                {{
                                                qldData?.meta?.reliefRole == 'N'
                                                ? 'Normal'
                                                : qldData?.meta?.reliefRole == 'T'
                                                ? 'Temp'
                                                : qldData?.meta?.reliefRole == 'B'
                                                ? 'Both LRT/DRT'
                                                : qldData?.meta?.reliefRole == 'L'
                                                ? 'LRT'
                                                : qldData?.meta?.reliefRole == 'D'
                                                ? 'DRT'
                                                : ''
                                                }}
                                            </span>
                                        </p>
                                        @if(schoolProps.properties.user_type == 'Tracer' ||
                                        schoolProps.properties.user_type == 'School'){
                                        <p class="txt-regular mt-8" *ngIf="schoolProps.properties.role_code != 'AT'">
                                            NoFC flag:
                                            <span class="text-regular-bold ms-2">{{qldData?.meta?.nofc == 'A' ? 'Casual
                                                and Temp' : qldData?.meta?.nofc == 'C' ? 'Casual' : 'iNotice'}}</span>
                                        </p>
                                        <p class="txt-regular mt-8">
                                            Reasonable adjustment:
                                            <span class="text-regular-bold ms-2">{{qldData?.meta?.reasonableAdjustment
                                                == 'N' ? 'No' : 'Yes'}}</span>
                                        </p>
                                        }
                                        @if(schoolProps.properties.user_type == 'Tracer'){
                                        <p class="txt-regular mt-8">
                                            Termination date:
                                            <span class="text-regular-bold ms-2">{{qldData?.inactive_date}}</span>
                                        </p>
                                        }
                                    </div>
                                </div>
                            </div>
                            <!-- Safeguarding questions -->
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="safeguardingHeading">
                                    <button class="accordion-button collapsed grey-2 text-regular-bold" type="button"
                                        data-bs-toggle="collapse" data-bs-target="#safeguardingCollapse"
                                        aria-expanded="false" aria-controls="safeguardingCollapse">
                                        Contact Details
                                        <span class="">
                                            <!-- Down arrow SVG -->
                                            <svg width="16" height="16" fill="currentColor"
                                                class="bi bi-caret-down-fill ms-2" viewBox="0 0 16 16">
                                                <path
                                                    d="M7.247 11.14l-4.796-5.481C1.825 5.21 2.16 4.5 2.813 4.5h10.374c.653 0 .988.71.362 1.159l-4.796 5.481a1 1 0 0 1-1.506 0z" />
                                            </svg>
                                        </span>
                                    </button>
                                </h2>
                                <div id="safeguardingCollapse" class="accordion-collapse collapse"
                                    aria-labelledby="safeguardingHeading">
                                    <div class="accordion-body p-0">
                                        <p class="txt-regular mt-8">
                                            Preferred first name:<span
                                                class="text-regular-bold ms-2">{{profileData?.user_data?.user?.first_name}}</span>
                                        </p>
                                        <p class="txt-regular mt-8">
                                            Preferred last name:<span
                                                class="text-regular-bold ms-2">{{profileData?.user_data?.user?.last_name}}</span>
                                        </p>
                                        <!-- <p class="txt-regular mt-8">
                                            Previous last name:<span
                                                class="text-regular-bold ms-2">{{qldData?.employee_details?.previous_last_name}}</span>
                                        </p> -->
                                        <p *ngIf="schoolProps.properties.role != 'My Bookings'"
                                            class="txt-regular mt-8">
                                            Preferred phone number:<span
                                                class="text-regular-bold ms-2">{{profileData?.user_data?.phone}}</span>
                                        </p>
                                        <p *ngIf="schoolProps.properties.role != 'My Bookings'"
                                            class="txt-regular mt-8">
                                            Secondary phone number:<span
                                                class="text-regular-bold ms-2">{{profileData?.user_data?.meta?.emergency_contact?.secondary_phone_number}}</span>
                                        </p>
                                        <p *ngIf="schoolProps.properties.role != 'My Bookings'"
                                            class="txt-regular mt-8">
                                            Email address:<span
                                                class="text-regular-bold ms-2">{{profileData?.user_data?.user?.email}}</span>
                                        </p>
                                        <!-- @if(userRole === 'School'){ -->
                                        <p *ngIf="schoolProps.properties.role != 'My Bookings'"
                                            class="txt-regular mt-8">
                                            Emergency contact name 1:<span
                                                class="text-regular-bold ms-2">{{profileData?.user_data?.meta?.emergency_contact?.emergency_contact_name1}}</span>
                                            <!-- <span class="emergency-tag ms-2" *ngIf="profileData?.user_data?.meta?.emergency_contact?.emergency_contact_relation1">{{profileData?.user_data?.meta?.emergency_contact?.emergency_contact_relation1}}</span> -->
                                        </p>
                                        <p *ngIf="schoolProps.properties.role != 'My Bookings'"
                                            class="txt-regular mt-8">
                                            Emergency contact phone 1:<span
                                                class="text-regular-bold ms-2">{{profileData?.user_data?.meta?.emergency_contact?.emergency_contact_phone1}}</span>
                                        </p>
                                        <p *ngIf="schoolProps.properties.role != 'My Bookings'"
                                            class="txt-regular mt-8">
                                            Relationship:<span
                                                class="text-regular-bold ms-2">{{profileData?.user_data?.meta?.emergency_contact?.emergency_contact_relation1}}</span>
                                        </p>
                                        <p *ngIf="schoolProps.properties.role != 'My Bookings'"
                                            class="txt-regular mt-8">
                                            Emergency contact name 2:<span
                                                class="text-regular-bold ms-2">{{profileData?.user_data?.meta?.emergency_contact?.emergency_contact_name2}}</span>
                                            <!-- <span class="emergency-tag ms-2" *ngIf="profileData?.user_data?.meta?.emergency_contact?.emergency_contact_relation2">{{profileData?.user_data?.meta?.emergency_contact?.emergency_contact_relation2}}</span> -->
                                        </p>
                                        <p *ngIf="schoolProps.properties.role != 'My Bookings'"
                                            class="txt-regular mt-8">
                                            Emergency contact phone 2:<span
                                                class="text-regular-bold ms-2">{{profileData?.user_data?.meta?.emergency_contact?.emergency_contact_phone2}}</span>
                                        </p>
                                        <p *ngIf="schoolProps.properties.role != 'My Bookings'"
                                            class="txt-regular mt-8">
                                            Relationship:<span
                                                class="text-regular-bold ms-2">{{profileData?.user_data?.meta?.emergency_contact?.emergency_contact_relation2}}</span>
                                        </p>
                                        <!-- } -->
                                        <p class="txt-regular mt-8"
                                            *ngIf="schoolProps.properties.user_type == 'Teacher'">
                                            Address:<span
                                                class="text-regular-bold ms-2">{{profileData?.user_data?.address?.locality}}
                                                {{profileData?.user_data?.address?.street}}{{
                                                profileData?.address?.address_2 ? ' ,' + profileData?.address?.address_2
                                                : '' }}
                                                {{profileData?.user_data?.address?.city}}
                                                {{profileData?.user_data?.address?.address_timezone?.state}} -
                                                {{profileData?.user_data?.address?.postal_code}}</span>
                                        </p>
                                    </div>

                                </div>
                            </div>
                            <!-- Multiple choice questions -->
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="multipleChoiceHeading">
                                    <button class="accordion-button collapsed grey-2 text-regular-bold" type="button"
                                        data-bs-toggle="collapse" data-bs-target="#multipleChoiceCollapse"
                                        aria-expanded="false" aria-controls="multipleChoiceCollapse">
                                        Subjects & Teaching Levels
                                        <span class="">
                                            <!-- Down arrow SVG -->
                                            <svg width="16" height="16" fill="currentColor"
                                                class="bi bi-caret-down-fill ms-2" viewBox="0 0 16 16">
                                                <path
                                                    d="M7.247 11.14l-4.796-5.481C1.825 5.21 2.16 4.5 2.813 4.5h10.374c.653 0 .988.71.362 1.159l-4.796 5.481a1 1 0 0 1-1.506 0z" />
                                            </svg>
                                        </span>
                                    </button>
                                </h2>
                                <div id="multipleChoiceCollapse" class="accordion-collapse collapse"
                                    aria-labelledby="multipleChoiceHeading">
                                    <div class="accordion-body p-0">
                                        <!-- Multiple choice questions content here -->
                                        <p class="txt-regular mt-8">
                                            Subjects:
                                            <!-- chip.component.html -->
                                            <app-subject-chips [qualified]="qldData?.subject?.qualified"
                                                [unknown]="qldData?.subject?.unknown" [title]="'Subjects'"
                                                [maxVisible]="10">
                                            </app-subject-chips>
                                            <!-- <span *ngFor="let item of qldData?.subject?.capable"
                                                class="qld-sub-chip chip-capable">{{item}}</span>
                                            <span *ngFor="let item of qldData?.subject?.qualified"
                                                class="qld-sub-chip chip-qualified">{{item}}</span>
                                            <span *ngFor="let item of qldData?.subject?.unknown"
                                                class="qld-sub-chip chip-unknown">{{item}}</span> -->

                                        </p>
                                        <p class="txt-regular mt-8">
                                            Year levels:
                                            <span *ngFor="let item of qldData?.level?.display_level"
                                                class="qld-sub-chip chip-unknown">{{item}}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }@else {
            <p class="text-regular grey-4 mt-10 mb-10 fs-14">
                If you want to recommence working with the Queensland Department of Education, you will need to
                reactivate your profile. Please make sure you have an active application with Teach Queensland and
                current registration with the Queensland College of Teachers.
            </p>
            <a class="c-p text-regular-bold clr-cc-vilot" [class.input-cursor-na]="!qldData?.can_reactivate"
                (click)="reactivateQLDAccount()">
                <i class="bi bi-person-dash me-1"></i>Reactivate here
            </a>
            <p class="fs-13 clr-red mt-5" *ngIf="!qldData?.can_reactivate">
                Please wait 30 minutes after deactivation before reactivating your account
            </p>
            }
        </div>
    </div>
    <!-- QLD Profile Completion -->
    <ng-template #qldProfileCompletionModal>
        <form [formGroup]="qldProfileForm">
            <div class="modal-header">
                <h5 class="modal-title">
                    Complete your profile to get booked by Queensland Department of Education schools.
                </h5>
                <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"></button>
            </div>
            <div class="modal-body pb-0 bce_questions">
                <!-- Stepper UI -->
                <!-- Stepper UI for BCE Modal -->
                <div class="bce-stepper d-flex align-items-center justify-content-center mb-5 mt-10">
                    <!-- Step 1 -->
                    <div class="step-circle" [ngClass]="{ active: step === 1, completed: step > 1 }"></div>
                    <div class="step-line" [ngClass]="{ active: step > 1 }"></div>
                    <!-- Step 2 -->
                    <div class="step-circle" [ngClass]="{ active: step === 2, completed: step > 2 }"></div>
                    <div class="step-line" [ngClass]="{ active: step > 2 }"></div>
                    <!-- Step 3 -->
                    <div class="step-circle" [ngClass]="{ active: step === 3 }"></div>
                </div>
                <div class="bce-step-labels d-flex justify-content-between mb-15 px-2">
                    <span class="step-label txt-regular"
                        [ngClass]="{ active: step === 1, completed: step > 1 }">Employee Details<br />view only</span>
                    <span class="step-label txt-regular" [ngClass]="{ active: step === 2, completed: step > 2 }">Contact
                        Details</span>
                    <span class="step-label txt-regular" [ngClass]="{ active: step === 3 }">Subjects & Levels</span>
                </div>
                <div *ngIf="step === 1" formGroupName="employeeDetails">
                    <div class="row">
                        <div class="col-md-6 mt-15">
                            <label class="form-label">Legal first name</label>
                            <input onlyAlphabetWithSpace formControlName="legal_first_name" type="text"
                                class="form-control" />
                        </div>
                        <div class="col-md-6 mt-15">
                            <label class="form-label">Legal last name</label>
                            <input onlyAlphabetWithSpace formControlName="legal_last_name" type="text"
                                class="form-control" />
                        </div>

                        <div class="col-md-6 mt-15">
                            <label class="form-label">Date of birth</label>
                            <input formControlName="dob" type="text" class="form-control" />
                        </div>

                        <div class="col-md-6 mt-15">
                            <label class="form-label">Employee number</label>
                            <input onlyNumbers formControlName="employee_id" type="text" class="form-control" />
                        </div>

                        <!-- <div class="col-md-6 mt-15">
                            <label class="form-label">Work Eligibility</label>
                            <input formControlName="work_eligibility" type="text" class="form-control" />
                        </div> -->

                        <!-- <div class="col-md-6 mt-15">
                            <label class="form-label">Visa Expiry</label>
                            <input formControlName="visa_expiry_date" type="text" class="form-control" />
                        </div> -->

                        <!-- <div class="col-md-6 mt-15">
                            <label class="form-label">QCT Registration Number</label>
                            <input formControlName="qct_number" type="text" class="form-control" />
                        </div> -->

                        <!-- <div class="col-md-6 mt-15">
                            <label class="form-label">QCT Evidence</label>
                            <input formControlName="qct_evidence" type="text" class="form-control" />
                        </div> -->

                        <!-- <div class="col-md-6 mt-15">
                            <label class="form-label">QCT Annual Fee Due</label>
                            <input formControlName="qct_annual_fee_due" type="date" class="form-control" />
                        </div> -->

                        <!-- <div class="col-md-6 mt-15">
                            <label class="form-label">All Staff Training</label>
                            <input formControlName="all_staff_training" type="text" class="form-control" />
                        </div> -->

                        <!-- <div class="col-md-6 mt-15">
                            <label class="form-label">Student Protection</label>
                            <input formControlName="student_protection" type="text" class="form-control" />
                        </div> -->

                        <!-- <div class="col-md-6 mt-15">
                            <label class="form-label">CARA</label>
                            <input formControlName="cara" type="text" class="form-control" />
                        </div> -->

                        <!-- <div class="col-md-6 mt-15">
                            <label class="form-label">Mandatory Training Status</label>
                            <input formControlName="mandatory_training" type="text" class="form-control" />
                        </div> -->

                        <div class="col-md-6 mt-15">
                            <label class="form-label">QCT number</label>
                            <input onlyNumbers formControlName="qct_number" type="text" class="form-control" />
                        </div>
                        <div class="col-md-6 mt-15">
                            <label class="form-label">Relief role</label>
                            <input onlyAlphabetWithSpace formControlName="relief_role" type="text"
                                class="form-control" />
                        </div>
                    </div>

                    <div class="modal-footer pt-0">
                        <button type="button" class="btn cc_p_btn fs_13" (click)="goToStep(2)">
                            Next
                        </button>
                    </div>
                </div>


                <!-- Step 2: Safeguarding Questions -->
                <div *ngIf="step === 2" formGroupName="contactDetails">
                    <div class="row">
                        <div class="col-lg-6 mt-15">
                            <label class="form-label">Preferred first name </label>
                            <input onlyAlphabetWithSpace formControlName="preferred_first_name" placeholder="Type here"
                                type="text" class="form-control" />
                        </div>
                        <div class="col-lg-6 mt-15">
                            <label class="form-label">Preferred last name </label>
                            <input onlyAlphabetWithSpace formControlName="preferred_last_name" placeholder="Type here"
                                type="text" class="form-control" />
                        </div>
                    </div>
                    <div class="row">
                        <!-- <div class="col-lg-6 mt-15">
                            <label class="form-label">Previous Last name</label>
                            <input formControlName="previous_last_name" placeholder="Type here" type="text"
                                class="form-control" />
                            <div *ngIf="isInvalid('contactDetails', 'previous_last_name')" class="invalid-feedback-qld">
                                Previous last name is required.
                            </div>
                        </div> -->
                        <div class="col-lg-12 mt-15">
                            <label class="form-label">Gender </label>
                            <select formControlName="gender" class="form-select">
                                <option value="">Select gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                                <option value="Prefered not to say">I'd rather not say</option>
                            </select>
                        </div>
                    </div>

                    <h1 class="text-regular-medium fs-18 mt-15">Address</h1>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 mt-15">
                            <label class="form-label">Country </label>
                            <input formControlName="country" type="text" placeholder="Enter country"
                                class="form-control" />
                        </div>
                        <div class="col-lg-6 col-md-6 mt-15">
                            <label class="form-label">State </label>
                            <input formControlName="state" type="text" placeholder="Enter state" class="form-control" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 mt-15">
                            <label class="form-label">Street number </label>
                            <input formControlName="street_number" type="text" placeholder="Enter street number"
                                class="form-control" />
                        </div>
                        <div class="col-lg-6 col-md-6 mt-15">
                            <label class="form-label">Street name </label>
                            <input formControlName="street_name" type="text" placeholder="Enter street name"
                                class="form-control" />
                        </div>
                        <div class="col-lg-6 col-md-6 mt-15">
                            <label class="form-label">City or Suburb </label>
                            <input formControlName="suburb" type="text" placeholder="Enter city or suburb"
                                class="form-control" />
                        </div>
                        <div class="col-lg-6 col-md-6 mt-15">
                            <label class="form-label">Postal code </label>
                            <input formControlName="postcode" type="text" placeholder="Enter postal code"
                                class="form-control" />
                        </div>
                    </div>

                    <h1 class="text-regular-medium fs-18 mt-15">Contact</h1>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 mt-15">
                            <label class="form-label">Preferred phone number </label>
                            <input formControlName="mobile_number" type="text"
                                placeholder="Enter preferred phone number" class="form-control" />
                        </div>
                        <div class="col-lg-6 col-md-6 mt-15">
                            <label class="form-label">Email </label>
                            <input formControlName="email_address" type="text" placeholder="Enter email"
                                class="form-control" />
                        </div>
                        <div class="col-lg-6 col-md-6 mt-15">
                            <label class="form-label">Secondary phone number </label>
                            <input onlyMobileNumber formControlName="secondary_phone_number" type="text"
                                placeholder="Enter secondary phone number" class="form-control" />
                        </div>
                    </div>
                    <h1 class="text-regular-medium fs-18 mt-15">Emergency Contacts</h1>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 mt-15">
                            <label class="form-label">Emergency contact name 1 <span
                                    class="text-danger">*</span></label>
                            <input onlyAlphabetWithSpace formControlName="emergency_contact_name1" type="text"
                                placeholder="Enter name" class="form-control" />
                            <div *ngIf="isInvalid('contactDetails', 'emergency_contact_name1')"
                                class="invalid-feedback-qld">
                                Emergency contact name 1 is required.
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 mt-15">
                            <label class="form-label">Emergency contact phone 1 <span
                                    class="text-danger">*</span></label>
                            <input onlyMobileNumber formControlName="emergency_contact_phone1" type="text"
                                placeholder="Enter phone number" class="form-control" />
                            <div *ngIf="isInvalid('contactDetails', 'emergency_contact_phone1')"
                                class="invalid-feedback-qld">
                                Please enter a valid phone number
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-6 mt-15">
                            <label class="form-label">Relationship <span class="text-danger">*</span></label>
                            <input onlyAlphabetWithSpace formControlName="emergency_contact_relation1" type="text"
                                placeholder="e.g., Parent, Spouse" class="form-control" />
                            <div *ngIf="isInvalid('contactDetails', 'emergency_contact_relation1')"
                                class="invalid-feedback-qld">
                                Please enter a valid information
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 mt-15">
                            <label class="form-label">Emergency contact name 2 <span
                                    class="text-danger">*</span></label>
                            <input onlyAlphabetWithSpace formControlName="emergency_contact_name2" type="text"
                                placeholder="Enter name" class="form-control" />
                            <div *ngIf="isInvalid('contactDetails', 'emergency_contact_name2')"
                                class="invalid-feedback-qld">
                                Emergency contact name 2 is required.
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 mt-15">
                            <label class="form-label">Emergency contact phone 2 <span
                                    class="text-danger">*</span></label>
                            <input onlyMobileNumber formControlName="emergency_contact_phone2" type="text"
                                placeholder="Enter phone number" class="form-control" />
                            <div *ngIf="isInvalid('contactDetails', 'emergency_contact_phone2')"
                                class="invalid-feedback-qld">
                                Please enter a valid phone number
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-6 mt-15">
                            <label class="form-label">Relationship <span class="text-danger">*</span></label>
                            <input onlyAlphabetWithSpace formControlName="emergency_contact_relation2" type="text"
                                placeholder="e.g., Parent, Spouse" class="form-control" />
                            <div *ngIf="isInvalid('contactDetails', 'emergency_contact_relation2')"
                                class="invalid-feedback-qld">
                                Please enter a valid information
                            </div>
                        </div>
                    </div>

                    <hr class="mb-10 mt-10" />
                    <div class="modal-footer pt-0">
                        <button type="button" class="btn-outline" (click)="goToStep(1)">
                            Back
                        </button>
                        <button type="button" [disabled]="!this.qldProfileForm.get('contactDetails')?.valid"
                            class="btn cc_p_btn fs_13" (click)="goToStep(3)">
                            Next
                        </button>
                    </div>
                </div>


                <!-- Step 3: Multiple Choice Questions -->
                <div *ngIf="step === 3" formGroupName="subjectsAndLevels">
                    <div class="mb-10">
                        <ng-container
                            *ngIf="qldData?.role_type !== 'LRT' && qldData?.role_type !== 'DRT'; else showSelectedSubjects">
                            <!-- <ng-select [dropdownPosition]="'bottom'" formControlName="subjects" [items]="subjects"
                                [multiple]="true" bindLabel="title" bindValue="value"
                                placeholder="Search by subject"></ng-select> -->
                            <div class="col-12">
                                @if(selectedQualifiedSub.length > 0){
                                <span class="form-label">Selected Subjects</span>
                                <div class="d-flex flex-wrap">
                                    <span *ngFor="let subject of selectedQualifiedSub" class="qld-sub-chip"
                                        style="cursor: pointer"
                                        [ngClass]="qldData?.subject?.selected_qualified?.includes(subject) ? 'chip-qualified' : 'chip-unknown'">
                                        {{ subject }} <span
                                            *ngIf="!qldData?.subject?.selected_qualified?.includes(subject)">&nbsp;(unknown)</span>
                                        <span class="ms-2"
                                            [class.input-cursor-na]="qldData?.subject?.selected_qualified?.includes(subject)"
                                            (click)="removeSchool(subject)" style="cursor: pointer">&times;</span>
                                    </span>
                                </div>
                                }
                                <div class="form-group">
                                    <label for="subjectSearch">Subjects</label>
                                    <input type="text" class="form-control" placeholder="Search by subjects"
                                        id="subjectSearch" (input)="filterSubjects($event)" value="" />
                                </div>
                                <!-- Always visible list with fixed height -->
                                <div class="form-group mt-10 mb-3 border rounded p-2"
                                    style="max-height: 200px; overflow-y: auto">
                                    <div *ngFor="let subject of filteredSubjects" class="form-check">
                                        <input class="form-check-input mt-4"
                                            [class.input-cursor-na]="qldData?.subject?.selected_qualified?.includes(subject)"
                                            type="checkbox" name="subjects" [checked]="isSelected(subject)"
                                            (change)="toggleSelection(subject)" id="{{ subject }}" />
                                        <label class="form-check-label" for="{{ subject }}"
                                            [class.input-cursor-na]="qldData?.subject?.selected_qualified?.includes(subject)">
                                            {{ subject }}
                                        </label>
                                    </div>
                                    <div *ngIf="filteredSubjects.length === 0" class="text-center text-muted py-4">No
                                        subjects found.</div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #showSelectedSubjects>
                            <br />
                            <ng-container *ngIf="qldData?.subject?.selected_subject?.length > 0; else noSubjects">
                                <span *ngFor="let item of qldData?.subject?.selected_subject"
                                    class="qld-sub-chip chip-unknown">{{item}}</span>
                            </ng-container>
                            <ng-template #noSubjects>
                                <span class="text-regular grey-4">No subjects selected</span>
                            </ng-template>
                        </ng-template>
                    </div>
                    <div class="mb-20">
                        <label class="form-label">Teaching levels</label>
                        <ng-container
                            *ngIf="qldData?.role_type !== 'LRT' && qldData?.role_type !== 'DRT'; else showSelectedLevels">
                            <ng-select [dropdownPosition]="'bottom'" formControlName="levels" [items]="teachingLevels"
                                [multiple]="true" bindLabel="title" bindValue="value"
                                placeholder="Search by level"></ng-select>
                        </ng-container>
                        <ng-template #showSelectedLevels>
                            <br />
                            <ng-container *ngIf="qldData?.level?.display_level?.length > 0; else noLevels">
                                <span *ngFor="let item of qldData?.level?.display_level"
                                    class="qld-sub-chip chip-unknown">{{item}}</span>
                            </ng-container>
                            <ng-template #noLevels>
                                <span class="text-regular grey-4">No levels selected</span>
                            </ng-template>
                        </ng-template>
                    </div>
                    <div class="modal-footer pt-0">
                        <button type="button" class="btn-outline" (click)="goToStep(2)">
                            Back
                        </button>
                        <button type="button" class="btn cc_p_btn fs_13" (click)="submitQLDForm()">
                            Submit
                        </button>
                    </div>
                </div>


            </div>
        </form>
    </ng-template>

    <!-- Success Profile Completion -->
    <ng-template #successProfileCompletionModal>
        <div class="modal-header">
            <h5 class="modal-title">
                You’re almost there
            </h5>
            <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"></button>
        </div>
        <div class="modal-body text-center">
            <img class="n_df" src="assets/images/NoResultFound/preConfirm/addCasuals.png"
                alt="Add schools to your preference list to start getting booked.">
            <p class="para_modal">Add schools to your preference list to start getting booked.</p>
        </div>
        <div class="modal-footer justify-content-end">
            <button type="button" class="btn cc_p_btn fs_13" (click)="navigateToFindSchools()">
                Find new schools
            </button>
        </div>
    </ng-template>

    <ng-template #deactivateSuccessModal>
        <div class="modal-body text-center pb-0 pt-30">
            <img src="assets/images/deactivate_img.png" alt="Success" class="mb-20" style="width: 120px" />
            @if(typeOfDeleteAction == 'deactivate-only') {
            <p class="user-title fs-20">Your account is deactivated</p>
            <p class="txt-regular fs-14 mt-10">
                Your request to deactivate your profile as a relief teacher has now been finalised. Please be advised
                that, from this point forward, you will no longer be considered for school booking requests with the
                Queensland Department of Education.
            </p>
            <p class="txt-regular fs-14 mt-20">
                If you believe this has been done in error, or you wish to reactivate your account, please <span
                    class="clr-cc-vilot text-center c-p h_b u_l" (click)="reactivateQLDAccountInfo()">click here</span>
                to reactivate your profile.
            </p>
            }@else if(typeOfDeleteAction == 'future-deactivate') {
            /<p class="user-title fs-20">Warning</p>
            <p class="txt-regular fs-14 mt-10">
                Your request to deactivate your account cannot be completed at this time as there are existing future
                dated bookings. Please cancel your future dated bookings and alert the booked schools, prior to
                deactivation.
            </p>
            }@else if(typeOfDeleteAction == 'reactivate-only') {
            <p class="user-title fs-20">Your account is activated</p>
            <p class="txt-regular fs-14 mt-10">
                Congratulations! Your account has been successfully activated.
            </p>
            }@else if(typeOfDeleteAction == 'future-delete') {
            <p class="user-title fs-20">Warning</p>
            <p class="txt-regular fs-14 mt-10">
                Your request to delete your account cannot be completed at this time as there are existing future dated
                bookings. Please cancel your future dated bookings and alert the booked schools, prior to deletion.
            </p>
            }
        </div>

        <div class="modal-footer delete_deactive text-center mt-10">
            <button type="button" class="btn cc_p_btn fs_13" (click)="bsModalRef.hide();refreshPage();">
                Okay
            </button>
        </div>
    </ng-template>
</div>


<!-- LRT/DRT available for all or part of this booking -->
<ng-template #QLDDeactivationConfirmationModal>
    <div class="modal-header">
        <h5 class="modal-title">Are you sure you want to deactivate {{ profileData?.user?.full_name }}?</h5>
        <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"></button>
    </div>
    <div class="modal-body">
        <p class="text-regular-medium mt-20">
            Are you sure you want to proceed with deactivating your account? By confirming, your profile will be
            deactivated and you will no longer receive booking requests from Queensland Department of Education schools.
            If you wish to work with the Queensland Department of Education in the future, you can reactivate your
            profile at any time. Please note that it may take up to 30 minutes for the deactivation to take effect.
        </p>
    </div>
    <div class="modal-footer">
        <button type="button" (click)="deactivateQLDAccount()" class="btn cc_p_btn fs_13">
            Deactivate
        </button>
    </div>
</ng-template>